import React, { useEffect, useState } from 'react'
import "./Sidebar_Principal.scss"
import { authenticationService } from 'services/authentication.service';
import CardPersonal from 'components/Varios/CardPersonal';
import Card_Sidebar_Principal from './Card_Sidebar_Principal';
import Sidebar_Principal_Content from './Sidebar_Principal_Content';
// Para efectos
import { Transition } from 'react-transition-group'
//Contexto de la barra
import { useSideBarContext } from 'Context/SideBarContext';
//Componentes usados
import Sidebar_Principal_Row from './Sidebar_Principal_Row';
import Sidebar_Principal_Submenu from './Sidebar_Principal_Submenu';
import Sidebar_Principal_Datos_Personales from './Sidebar_Principal_Datos_Personales';
import Sidebar_Principal_SubmenuNieto from './Sidebar_Principal_subMenuNieto';
import { ReactComponent as Flecha_Regreso } from "assets/icons/Sidebar_Nuevo_Opciones/regreso.svg"
import { ReactComponent as Flecha_Ir } from "assets/icons/Sidebar_Nuevo_Opciones/flecha.svg"
import Sidebar_Principal_SubmenuCuartoNivel from './Sidebar_Principal_subMenuCuartoNivel';

export const Icono_Flecha_Regreso = <Flecha_Regreso className="iconoFlechaRegreso" />
export const Icono_Flecha_Ir = <Flecha_Ir className="iconoFlechaIr" />

export interface Props_Sidebar_Principal {
    activeOption?: string,
    onClickOverlay?: () => void
}

export type UserData = {
    usuario: string,
    idpersona: number,
    identificacion: string,
    apellidos: string
    nombres: string
    genero: string
    ultimoCambio: string
    roles: Array<string>,
    roles_usuario: Array<string>,
    regimen_usuario: Array<number>,
    token: string,
    periodo_planificacion_vac_activo: boolean,
    tipo_director_unidad: string,
    showModalActualizarDP: boolean,
    soloTieneContratoESPOLTECH: boolean,
    soloTieneSolicitudContratacion:boolean,
    estructuraOrganicaConsultor: number,
    estadosDesvinculacion: Array<string>,
    ultimoCambioDatosPersonales: string | undefined,
    referenciaFotoWeb: string,
    tieneHorarioJornadaEspecial:boolean
}

export default function Sidebar_Principal(props: Props_Sidebar_Principal) {
    const [activeOption, setactiveOption] = useState<string>("");
    const [currentUser, setcurrentUser] = useState<UserData | null>(null);
    const [toogle, settoogle] = useState<boolean>(false)
    const { subMenu, subMenuDatosPersonales, subMenuNieto, subMenuCuartoNivel, setshowSideBar, showSideBar } = useSideBarContext();

    const TIMEOUT = 400;

    useEffect(() => {
        const subscription = authenticationService.currentUser.subscribe(data_user => setcurrentUser(data_user));
        return () => {
            subscription.unsubscribe();
        };
    }, [])

    const { onClickOverlay } = props;
    const barra_navegacion_principal = (): JSX.Element => {
        if (currentUser != null) {
            return (
                <React.Fragment>

                    <div id="sidenavPrincipal"  >

                        <Card_Sidebar_Principal datos_usuario={currentUser} />

                        <Transition
                            in={!subMenu}
                            timeout={TIMEOUT}
                            unmountOnExit
                            mountOnEnter

                        >
                            {state => (

                                <Sidebar_Principal_Content state_transition={state} datos_usuario={currentUser} />
                            )}
                        </Transition>

                        <Transition
                            in={subMenu && !subMenuNieto}
                            timeout={TIMEOUT}
                            unmountOnExit
                            mountOnEnter
                        >
                            {state => (
                                <Sidebar_Principal_Submenu state_transition={state} datos_usuario={currentUser} />
                            )}
                        </Transition>

                        <Transition
                            in={subMenuDatosPersonales}
                            timeout={TIMEOUT}
                            unmountOnExit
                            mountOnEnter
                        >
                            {state => (
                                <Sidebar_Principal_Datos_Personales datos_usuario={currentUser} state_transition={state} />
                            )}
                        </Transition>

                        <Transition
                            in={subMenuNieto && !subMenuCuartoNivel && !subMenuDatosPersonales}
                            timeout={TIMEOUT}
                            unmountOnExit
                            mountOnEnter
                        >
                            {state => (
                                <Sidebar_Principal_SubmenuNieto state_transition={state} datos_usuario={currentUser} />
                            )}
                        </Transition>

                        <Transition
                            in={subMenuCuartoNivel}
                            timeout={TIMEOUT}
                            unmountOnExit
                            mountOnEnter
                        >
                            {state => (
                                <Sidebar_Principal_SubmenuCuartoNivel state_transition={state} datos_usuario={currentUser} />
                            )}
                        </Transition>
                    </div>

                    {
                        typeof (onClickOverlay) === "function" &&
                        <div className="OverlaySideBar" onClick={() => onClickOverlay()}></div>
                    }

                    {
                        typeof (onClickOverlay) === undefined &&
                        <div className="OverlaySideBar" ></div>
                    }

                </React.Fragment>
            )
        }
        return <div></div>
    }

    return barra_navegacion_principal();
}